import TimelineView from './components/TimelineView'
import timelineItemsList from './data'

import './App.css'

const App = () => <TimelineView timelineItemsList={timelineItemsList} />

export default App
